/* @ngInject */
const axletreeMetadata = (
  axletreeFields
) => {
  const self = {}

  self.favoriteSort = ['position',]

  self.fields = axletreeFields

  return self
}
export default axletreeMetadata



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/axletree/services/metadata.service.js